/**
 * Loads the Google Maps JS API once per page and caches the promise so every
 * caller shares the same <script> tag.
 */
let loaderPromise = null

export const MAPS_API_KEY = import.meta.env.VITE_GOOGLE_MAPS_API_KEY || ''

export function loadGoogleMaps() {
  if (typeof window === 'undefined') return Promise.reject(new Error('No window'))
  if (window.google?.maps) return Promise.resolve(window.google.maps)
  if (loaderPromise) return loaderPromise

  if (!MAPS_API_KEY) {
    return Promise.reject(new Error('Missing VITE_GOOGLE_MAPS_API_KEY'))
  }

  loaderPromise = new Promise((resolve, reject) => {
    const callbackName = '__coeaterGoogleMapsReady'
    window[callbackName] = () => {
      delete window[callbackName]
      resolve(window.google.maps)
    }
    const script = document.createElement('script')
    script.src = `https://maps.googleapis.com/maps/api/js?key=${MAPS_API_KEY}&loading=async&callback=${callbackName}`
    script.async = true
    script.defer = true
    script.onerror = () => {
      loaderPromise = null
      delete window[callbackName]
      reject(new Error('Failed to load Google Maps'))
    }
    document.head.appendChild(script)
  })

  return loaderPromise
}
